import BusType from "@Route/types/type/Bus.type";
import FerryType from "@Route/types/type/Ferry.type";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";
import {isFerryRoute} from "@Route/features/transportType/functions/isFerryRoute";

export const mightBeMinibus = (vehicle: BusType | FerryType, routeTransferType: RouteTransferTypeKeys) => (
    !isFerryRoute(vehicle, routeTransferType) && vehicle?.mightBeMinibus
)
